var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',[_c('v-card-title',{staticStyle:{"background-color":"#006699","color":"white"}},[_vm._v("Visualização do comprovativo")]),_c('v-card-text',[_c('v-row',[_c('v-col',{attrs:{"md":"12"}},[_c('img',{attrs:{"src":_vm.file}})])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }